import { useField } from '@kizi/comparator-core';
import { Div, P } from '@kizi/core-components';
import React from 'react';
import { DetailsTabProps } from '.';
import { formatPrice } from '../../../../../utils/global';

export const DetailsTabSolarPanels: React.FC<DetailsTabProps> = ({ data }) => {
  const details = data.coverageHomes.map((el) => {
    return {
      label: el.externalSourceName,
      quantity: el.solarPanels[0].quantity,
    };
  });

  const roofTypeField = useField('getHouseInput.roofType');
  const roofType = roofTypeField?.value;

  let roofTypeLabel;
  switch (roofType) {
    case 'platdak':
      roofTypeLabel = '(plat dak)';
      break;
    // case 'schuinenplatdak':
    //   roofTypeLabel = '(schuin en plat dak)';
    //   break;
    default:
      roofTypeLabel = '(schuin dak)';
      break;
  }

  const productsField = useField('getHouseInput.products');
  const roofSurfaceField = useField('getHouseInput.roofSurface');
  const meterBoxField = useField('getHouseInput.meterBox');

  const products = JSON.parse(String(productsField?.value)).filter(
    (el) => el.associatedSuppliers[0] === Number(data.supplierExternalId)
  );
  const roofSurface = Number(roofSurfaceField?.value);
  const meterBox = meterBoxField?.value;

  let roofSurfaceCost = 0;
  let meterBoxCost = 0;

  if (roofSurface > 1) {
    roofSurfaceCost += parseFloat(
      products.filter((el) => [80409, 103764, 105422].includes(el.id))[0].price
    );
  }

  if (meterBox === 'stoppen') {
    meterBoxCost += parseFloat(
      products.filter((el) => [80410, 103768, 105426].includes(el.id))[0].price
    );
  }

  return (
    <>
      <P variant="footnoteRegular" mb={2}>{`Installatie ${roofTypeLabel}`}</P>
      {details.map((el) => (
        <Div
          key={el.label}
          display="flex"
          justifyContent="space-between"
          pl="16px"
          mb={1}
        >
          <P variant="footnoteRegularLightGrey" fontSize={2} fontWeight="300">
            {el.label}
          </P>
          <P
            variant="footnoteRegularLightGrey"
            fontSize={2}
            fontWeight="300"
          >{`x${el.quantity}`}</P>
        </Div>
      ))}
      {roofSurfaceCost > 0 && (
        <Div mt={2} display="flex" justifyContent="space-between">
          <P variant="footnoteRegular">{'Meerdere dakvlakken'}</P>
          <P variant="footnoteRegular" fontWeight="300">
            {formatPrice(roofSurfaceCost)}
          </P>
        </Div>
      )}
      {meterBoxCost > 0 && (
        <Div mt={2} display="flex" justifyContent="space-between">
          <P variant="footnoteRegular">{'Meterkast'}</P>
          <P variant="footnoteRegular" fontWeight="300">
            {formatPrice(meterBoxCost)}
          </P>
        </Div>
      )}
      <Div border="1px solid #2B2F3B" my={2} />
      <Div display="flex" justifyContent="space-between">
        <P variant="bodyImportant">{'Totale kosten'}</P>
        <P variant="bodyImportant">{formatPrice(data.priceInfo.total)}</P>
      </Div>
    </>
  );
};
